import { DateFormat, formatDate as formatDateUtil } from '@lyearn/core/utils/date/formatDate';
import { DateVariant } from '@lyearn/ui';

import { isFormDataValidFunction } from '../types';

// if timeFormat exists return Date with time otherwise return only date
export const getDisplayDate = (date?: string, timeFormat?: string | null) => {
  if (!date) {
    return '';
  }
  return timeFormat === DateVariant.DateAndTime
    ? formatDateUtil(new Date(date), DateFormat.DateTime)
    : formatDateUtil(new Date(date), DateFormat.Date);
};

export const isFormDataValid: isFormDataValidFunction = (data) => Boolean(data?.startTime);
